import React from 'react';

const Internet = () => (
  <div>
    <br /><br />
    <h2>Internet Service Details</h2>
    <p>Plan information coming soon</p>
  </div>
);

export default Internet;


// WEBPACK FOOTER //
// ./src/components/sections/services/internet.js